export const closeTargetedOffersPill = ({ updateState }) => {
	updateState({
		targetedOffersPillShow: false,
		targetedOffersPillClosed: true,
	});
};
